/**
 * PATH: packages/ui/src/kanban/components/KanbanCardAllocateHotkey.tsx
 * FILE_ID: UI-KANBAN-CARD-ALLOCATE-HOTKEY-UI-001
 * PURPOSE: Open the Allocate picker when A is pressed on a card.
 * ROLE IN ARCHITECTURE: Sibling of the hover rail, not inside it.
 * MAIN EXPORTS: KanbanCardAllocateHotkey
 * NON-RESPONSIBILITIES: Does not decide which card is hovered.
 * NOTES FOR FUTURE AI: The rail can be unmounted when A is pressed.
 *   This picker must stay on the card root or A shows nothing.
 */
import type { Card } from '../types'
import type { KanbanCardQuickActionHandlers } from './KanbanCard.types'
import { KanbanCardQuickActionPickers } from './KanbanCardQuickActionPickers'
import { triggerRectFromElement } from './placeBesideTrigger'

export function KanbanCardAllocateHotkey({
  card,
  handlers,
  onClose,
}: {
  card: Card
  handlers: KanbanCardQuickActionHandlers
  onClose: () => void
}) {
  const el = document.querySelector<HTMLElement>(
    `[data-card-id="${CSS.escape(card.id)}"]`,
  )
  if (!el) return null
  return (
    <KanbanCardQuickActionPickers
      open={{ kind: 'allocate', trigger: triggerRectFromElement(el) }}
      card={card}
      busy={false}
      assignBusyId={null}
      run={(fn) => {
        void Promise.resolve(fn()).finally(onClose)
      }}
      onAssignToggle={() => undefined}
      onClose={onClose}
      handlers={handlers}
    />
  )
}
